import AxiosConfig from "./AxiosConfig";

const saveRatingToLocal = (newValue, userId, rateTargetId) => {
    return new Promise((resolve, reject) => {
        if (typeof newValue !== 'number' || typeof userId !== 'number' || typeof rateTargetId !== 'number' || isNaN(newValue) || isNaN(userId) || isNaN(rateTargetId)) {
            console.error('Les paramètres {newValue, userId, rateTargetId} doivent être de type int.', newValue, userId, rateTargetId);
            return reject(new Error('Les paramètres {newValue, userId, rateTargetId} doivent être de type int.'));
        }

        const dataToStore = {
            value: newValue,
            user: userId,
            rateTarget: rateTargetId,
        };
        const ratingsData = JSON.parse(localStorage.getItem('ratingsData')) || [];
        const existingIndex = ratingsData.findIndex(rating =>
            rating.user === userId && rating.rateTarget === rateTargetId
        );
        if (existingIndex > -1) {
            ratingsData.splice(existingIndex, 1);
        }

        ratingsData.push(dataToStore);
        localStorage.setItem('ratingsData', JSON.stringify(ratingsData));

        const seancesData = JSON.parse(localStorage.getItem('seancesData')) || [];
        const foundSeanceIndex = seancesData.findIndex(s => s.id === rateTargetId);
        if (foundSeanceIndex > -1) {
            seancesData[foundSeanceIndex].rate.value = newValue;
            localStorage.setItem('seancesData', JSON.stringify(seancesData));
        } else {
            console.error('Séance non trouvée');
            return reject(new Error('Séance non trouvée'));
        }

        resolve(dataToStore);
    });
};

const saveRatingToAPI = async (value, seanceId) => {
    try {
        const response = await AxiosConfig.post(`/activite_seance_users/rating/set/${seanceId}`, { value });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la sauvegarde de la note : ", error);
        return { success: false, message: "Erreur lors de la sauvegarde de la note" };
    }
};

const getRatingLocal = (userId, id) => {
    return new Promise((resolve, reject) => {

        const storedData = JSON.parse(localStorage.getItem('ratingsData')) || [];
        const existingRating = storedData.find(rating => rating.user === userId && rating.rateTarget === id);

        resolve(existingRating);
    });
};

const getRatingApi = async (seanceId) => {
    const response = await AxiosConfig.get(`/activite_seance_users/rating/${seanceId}`);
    return response.data;
};

export { saveRatingToLocal, saveRatingToAPI, getRatingLocal, getRatingApi };
